module.exports = __webpack_public_path__ + "static/media/pencil-holder.f971690d.png";